/*
 * Copyright (c) Nexign, JSC, 2022-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @author Viacheslav Smalenski
 * @version 1.28.0
 * @since 1.20.0
 */

import styled from 'styled-components';

import { ImgStyled } from '@components/common/Block/Img';
import { colors } from '@theme/index';

export const InquiryFileItemStyled = styled.div`
    display: flex;
    margin-top: 8px;
    justify-content: space-between;

    &:first-child {
        margin-top: 16px;
    }

    ${ImgStyled} {
        margin-left: 4px;
    }

    &.failed {
        border: 1px solid ${colors.borderColorError};
        padding: 10px;
    }
`;

export const InquiryFileInputBlockStyled = styled.div`
    display: flex;
    align-items: center;
    column-gap: 5px;
`;

export const InquiryFileInputGlobalErrorBlockStyled = styled.div`
    margin: 10px 0;
    color: ${colors.textColorDanger};
`;

export const InquiryFileItemsContainerStyled = styled.aside`
    margin: 10px 0;
    width: 100%;

    &.rejected {
        border: 1px solid ${colors.borderColorError};
        padding: 10px;
    }
`;
